import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Link, Redirect, useLocation } from 'react-router-dom'
import LoginFields from 'forms/auth/login/fields'
import BodyClass from 'components/shared/body-class'
import Button from 'forms/shared/buttons'
import authActions from 'actions/auth/actions'

const Login = ({ csrfToken, formPath, isAuth, isMerchant, updateFormpath }) => {
  useEffect(() => {
    updateFormpath({ formPath: '/login' })
  }, [])
  const location = useLocation()
  const urlSearchParam = new URLSearchParams(location.search)
  const redirectTo = urlSearchParam.get('redirectTo')
  const redirectUrl = redirectTo || location?.search.split('=')[1] || ''

  return (
    <div className="flex flex-col min-h-screen justify-between">
      <BodyClass className="bg-secondary-lightgray" />
      <div className="w-full flex flex-col m-auto justify-center items-center pt-10 pb-10 pr-4 pl-4">
        {isAuth && <Redirect to={isMerchant ? '/merchant' : '/client'} push strict={true} />}
        <div className="bg-white w-full p-3 sm:p-5 lg:w-4/12 md:w-6/12 sm:w-10/12 shadow-loginbox rounded-sm">
          <div className="flex justify-between items-start xs:items-center mb-5 xs:flex-row flex-col">
            <h2 className="text-lg font-normal text-gray-700">Login</h2>
            <h4 className="text-sm text-primary-lightgray">
              Not registered yet?
              <Link to={`/register`} className="text-black ml-1">
                Sign up here
              </Link>
            </h4>
          </div>
          <div className="flex justify-between items-center mb-5 relative flex-col xs:flex-row">
            <a
              href={`/auth/google?redirect=${redirectUrl}`}
              className="text-white p-2 bg-secondary-google rounded-sm w-full xs:w-7/8 text-center"
            >
              <i className="fa fa-google mr-3"></i> Log in with Google
            </a>
          </div>
          <div className="flex justify-center items-center mb-5 relative">
            <div className="border-b border-gray-500 w-full absolute"></div>
          </div>
          <form method="POST" action={formPath}>
            <input type="hidden" name="_csrf" defaultValue={csrfToken} />
            <input type="hidden" name="redirectTo" value={redirectUrl} />
            <LoginFields />
            <Button buttonClassname="btn btn-primary font-normal" containerClassname={'text-left'}>
              LOGIN
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

Login.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isMerchant: PropTypes.bool,
  formPath: PropTypes.string,
  csrfToken: PropTypes.string,
  isAuth: PropTypes.bool,
  updateFormpath: PropTypes.func,
}

const mapStateToProps = ({ auth }) => ({
  isAuth: auth.authenticated,
  isMerchant: auth.authenticated && auth.user.roles.includes('merchant'),
  formPath: auth.formPath,
  csrfToken: auth.csrfToken,
})

const mapDispatchToProps = {
  updateFormpath: authActions.updateFormpath,
}

export const WrappedLogin = reduxForm({
  form: 'login-form',
})(Login)

export default connect(mapStateToProps, mapDispatchToProps)(WrappedLogin)
